import type { RowData } from '@tanstack/react-table';
import type { Column } from '@tanstack/table-core';
import { useTranslation } from 'react-i18next';
import Icon from '../../Icon';
import type { kkTableFeatures } from '../tableFeatures';

interface FilterSearchProps<TData extends RowData> {
  column: Column<typeof kkTableFeatures, TData, unknown> | undefined;
  close: () => void;
  inputClassName: string;
  label: React.ReactNode;
  onChange: (value: string) => void;
  value: string;
}

export function FilterSearch<TData extends RowData>({
  column,
  close,
  inputClassName,
  label,
  onChange,
  value,
}: FilterSearchProps<TData>) {
  const { t } = useTranslation('ui');

  return (
    <>
      <div className="laane:hidden md:hidden flex items-center justify-between px-2 pt-11 pb-7">
        <h2 className="typ-headline-lg">
          {column?.columnDef.meta?.filterTitleOverride ?? (
            <>
              <span className="mr-2">{t('select')}</span>
              <span className="lowercase">{label}</span>
            </>
          )}
        </h2>
        <button onClick={close}>
          <Icon type="cross" size="small" />
        </button>
      </div>
      <div className="relative">
        <Icon
          type="magnify"
          className="pointer-events-none absolute top-1/2 -translate-y-1/2 translate-x-2"
        />
        <input
          onChange={(event) => {
            onChange(event.target.value);
          }}
          name={t('search')}
          value={value}
          type="search"
          className={inputClassName}
          placeholder={column?.columnDef.meta?.filterPlaceholder ?? t('search')}
        />
      </div>
    </>
  );
}
